// Deactivated Tab (2026-02) — pure list-filtering helpers for the Administration staff list,
// split out of Admin.jsx purely so they're unit-testable (Admin.jsx itself fires live API
// calls on mount, so it isn't a good render-test target). Behaviour is unchanged from what was
// inline in Admin.jsx before this split.

// Must match backend SEED_ACCOUNT_EMAILS (kernel/auth.py) EXACTLY — this is the same list
// modules/admin.py::remove_user (~line 744) checks before hard-deleting. Keep in sync if
// SEED_ACCOUNTS ever changes.
export const SEED_ACCOUNT_EMAILS = new Set([
  "founder@njm.local", "partner@njm.local", "pm@njm.local", "coord@njm.local",
  "finance@njm.local", "creative@njm.local", "guest@njm.local",
  "freelancer_test@njm.local", "partner_test@njm.local", "freelancer_test_b@njm.local",
  "partner_test_b@njm.local", "freelancer_approved_test@njm.local", "freelancer_unapproved_test@njm.local",
]);

// True only for accounts the backend will actually hard-delete — NOT the same as
// `source === "demo"`, which also covers auth_provider="demo" test fixtures (random emails,
// not in SEED_ACCOUNT_EMAILS) that the backend would reject with 400 hard_remove_restricted_
// to_seed_accounts.
export function isHardDeletable(email) {
  return SEED_ACCOUNT_EMAILS.has((email || "").trim().toLowerCase());
}

// Splits the raw staff list into the two Deactivated-Tab buckets. Both are derived from the
// same source array, so a status change (deactivate/reactivate) moves a row between them on
// the next call with no extra bookkeeping.
export function splitStaffByActive(users) {
  return {
    active: users.filter((u) => u.active !== false),
    deactivated: users.filter((u) => u.active === false),
  };
}

// Search/role/source narrowing — applied on top of whichever Deactivated-Tab bucket is
// currently selected.
export function filterStaffUsers(users, { search, role, source } = {}) {
  return users.filter((u) => {
    if (search) {
      const s = search.trim().toLowerCase();
      if (!(u.name || "").toLowerCase().includes(s) && !(u.email || "").toLowerCase().includes(s)) return false;
    }
    if (role && u.role !== role) return false;
    if (source && u.source !== source) return false;
    return true;
  });
}
